import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';

import { ButtonComponent } from '../../components/buttons/button/button.component';
import { ErrorCardComponent } from '../../components/card/error-card/error-card.component';
import { InputComponent } from '../../components/inputs/input/input.component';
import { ErrorService } from '../../services';
import { AuthService } from '../../services/auth/auth.service';
import { LoadingService } from '../../services/loading/loading.service';
import { ToastService } from '../../services/toast/toast.service';
import { analyticsPageNames } from '../../shared';

@Component({
    selector: 'lib-reset-password-form',
    imports: [CommonModule, InputComponent, ButtonComponent, ReactiveFormsModule, ErrorCardComponent],
    templateUrl: './reset-password-form.component.html',
    styleUrl: './reset-password-form.component.css'
})
export class ResetPasswordFormComponent {
    /* eslint-disable */
    @Output() onResetSuccess: EventEmitter<string> = new EventEmitter();
    @Output() onResetFail = new EventEmitter();

    emailForm!: FormGroup;

    errors: any = null;

    constructor(
        private fb: FormBuilder,
        private authService: AuthService,
        private toastService: ToastService,
        private loadService: LoadingService,
        private errorService: ErrorService
    ) {
        this.emailForm = this.fb.group({
            email: ['', [Validators.required, Validators.email]]
        });
    }

    onInput() {
        this.errors = null;
    }

    submitRequest() {
        if (!this.emailForm.valid) return;

        this.errors = null;

        const email = this.emailForm.value.email;

        this.loadService.presentLoading();

        this.authService.requestPasswordReset(email).subscribe({
            next: data => {
                this.loadService.dismissLoading();

                if (data['success'] && data['success'] === true) {
                    this.authService.setForgotPasswordEmail(email);
                    this.onResetSuccess.emit();
                } else {
                    this.errorService.apiErrors(analyticsPageNames.forgotPassword, data, { Email: email });
                    this.toastService.errorToast({
                        message: `Could not find your email. Please check and try again`
                    });
                    this.errors = data.error;

                    this.authService.setForgotPasswordEmail(email);
                    this.onResetFail.emit(email);
                }
            },
            error: error => {
                this.loadService.dismissLoading();
                this.errors = error;

                const errorMessage = error.message ? error.message : error.statusText;

                this.errorService.apiErrors(analyticsPageNames.forgotPassword, errorMessage);

                this.toastService.errorToast({
                    message: errorMessage
                });

                this.authService.setForgotPasswordEmail(null);
                this.onResetFail.emit();
            }
        });
    }
}
